export default __webpack_public_path__ + "static/media/glitch19.9d35590e.png";